import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  FieldArray,
  propTypes as reduxFormPropTypes,
  reduxForm,
} from 'redux-form';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import CircularProgress from '@material-ui/core/CircularProgress';
import classNames from 'classnames';
import RenderAnswers from '../renderAnswers/RenderAnswers';
import CircularProgressLoader from '../../../../components/CircularProgressLoader/CircularProgressLoader';
import s from './QuestionsForm.scss';

const processQuestions = question => {
  const result = {
    _id: question._id,
    type: question.type,
    answers: question.type === 'fill in blank' ? '' : [],
  };

  if (!question.answer) {
    return result;
  }

  if (question.type === 'multiple choice') {
    result.answers = _.map(question.generalAnswers, item =>
      _.includes(question.answer.values, item.description),
    );
    return result;
  }

  result.answers = question.answer.values;

  return result;
};

@injectIntl
@withStyles(s)
@connect(state => ({
  loadingQuiz: state.viewQuiz.loading,
  quiz: state.viewQuiz.quiz,
  initialValues: {
    questions: _.map(state.viewQuiz.quiz.questions, processQuestions),
  },
  course: state.courseDetails.course,
}))
@reduxForm({
  form: 'viewQuizForm',
})
@connect(state => ({
  form: state.form.viewQuizForm,
}))
export default class QuestionsForm extends React.Component {
  static propTypes = {
    chooseQuestion: PropTypes.func.isRequired,
    finishQuiz: PropTypes.func.isRequired,
    loadingQuiz: PropTypes.bool.isRequired,
    isAnswerSending: PropTypes.bool.isRequired,
    questionNumber: PropTypes.number.isRequired,
    answeredQuestions: PropTypes.array, // eslint-disable-line
    ...reduxFormPropTypes,
    form: PropTypes.object.isRequired, // eslint-disable-line
  };

  static contextTypes = {
    fetch: PropTypes.func,
  };

  static defaultProps = {
    answeredQuestions: [],
  };

  submit = event => {
    event.preventDefault();

    const {
      chooseQuestion,
      questionNumber,
      quiz,
      finishQuiz,
      isAnswerSending,
    } = this.props;
    const isLastQuestion = questionNumber === quiz.questions.length - 1;

    if (isAnswerSending) {
      return;
    }

    if (isLastQuestion) {
      finishQuiz();
    } else {
      chooseQuestion(questionNumber + 1);
    }
  };

  render() {
    const {
      questionNumber,
      quiz,
      answeredQuestions,
      loadingQuiz,
      isAnswerSending,
      passingQuizError,
    } = this.props;

    if (loadingQuiz) {
      return (
        <div className={s.container}>
          <div className={s.loadingWrapper}>
            <CircularProgressLoader />
          </div>
        </div>
      );
    }

    return (
      <form
        onSubmit={this.submit}
        className={classNames(s.questionForm, 'notranslate')}
        id="questionForm"
      >
        <FieldArray
          name="questions"
          component={RenderAnswers}
          questionNumber={questionNumber}
          quiz={quiz}
          answeredQuestions={answeredQuestions}
          isAnswerSending={isAnswerSending}
        />
        {passingQuizError && (
          <span className={s.formError}>{passingQuizError}</span>
        )}
        {isAnswerSending && (
          <CircularProgress size={68} className={s.fabProgress} />
        )}
      </form>
    );
  }
}
